export default __webpack_public_path__ + "static/media/contact.bf9ad608.png";